import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';

const StyledModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background-color: ${rgba(theme.color.black, 0.6)};
`;

const StyledCloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 11;
`;

export { StyledModalContainer, StyledCloseButton };
